import { render, staticRenderFns } from "./Kind.vue?vue&type=template&id=6ab7098c&scoped=true&"
import script from "./Kind.vue?vue&type=script&lang=js&"
export * from "./Kind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab7098c",
  null
  
)

/* custom blocks */
import block0 from "./Kind.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports